import React from 'react'
import './AppleLoginButton.scss'
import state from './state'

class AppleLoginButton extends React.Component {
  componentDidMount() {
    AppleID.auth.init({
      clientId: state.appleAuth.clientId,
      scope: state.appleAuth.scope,
      redirectURI: state.appleAuth.redirectURI,
      state: state.appleAuth.state,
    })
  }

  render() {
    return (
      <div
        onClick={this.props.clickEvent}
        className="login-btn-apple"
        id="appleid-signin"
        data-text={this.props.children}
      />
    )
  }
}

export { AppleLoginButton }
